export const TestLicense = {
  SERVICE_CONTINUITY: ['EAX-PING-TRACERT-MA', 'EAX-PING-TRACERT-NSC'],
  MULTISTEP: ['EAX-MULTISTEP-WEB-MA'],
  VOIP: ['EAX-VOIP-MA', 'EAX-VOIP-NSC'],
  TRUESPEED: [
    'EAX-TS-MA',
    'EAX-TS-MTS-TBERD',
    'EAX-TS-ONX',
    'EAX-TS-PC-CLIENT',
    'EAX-TRUESPEED-NSC',
    'EAX-TRUESPEED-RF-JMEP',
    'EAX-TRUESPEED-QT600'
  ],
  Y1564: ['EAX-Y1564-MA', 'EAX-Y1564-TBERD-MTS', 'EAX-Y1564-QT600', 'EAX-Y1564-JMEP'],
  RFC2544: ['EAX-RFC2544-QT600', 'EAX-RFC2544-TBERD-MTS'],
  UDP: ['EAX-UDP-MA'],
  HTTP: ['EAX-HTTP-FTP-MA', 'EAX-HTTP-FTP-NSC'],
  BERT: ['EAX-BERT-JMEP']
};

export const ScheduleLicense = {
  SERVICE_CONTINUITY: ['EAX-SCHED-PING-TRACERT'],
  MULTISTEP: ['EAX-SCHED-MULTISTEP'],
  VOIP: ['EAX-SCHED-VOIP'],
  TRUESPEED: ['EAX-SCHED-TRUESPEED'],
  Y1564: ['EAX-SCHED-Y1564'],
  RFC2544: ['EAX-SCHED-RFC2544'],
  UDP: ['EAX-SCHED-UDP'],
  HTTP: ['EAX-SCHED-HTTP-FTP'],
  BERT: []
};
